const GTM_ID = process.env.REACT_APP_GTM_ID;

export const initGtm = () => {
  if (!GTM_ID || window.__gtmLoaded) return;
  window.__gtmLoaded = true;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(script);
};

export const pushEvent = (event, data = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...data });
};

export const trackPageView = (path) =>
  pushEvent("page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });

export const trackFormSubmit = (formName) =>
  pushEvent("generate_lead", { form_name: formName });
